import React, { useState } from 'react';
import _get from 'lodash/get';
import { useDispatch, useData } from 'resift';
import makeStyles from '@material-ui/styles/makeStyles';
import Autosuggest from '@sift/skipper/components/Autosuggest';
import DefaultSuggestion from '@sift/skipper/components/Autosuggest/DefaultSuggestion';
import withPopper from '@sift/skipper/components/Autosuggest/withPopper';
import makeGetSourceGroups from 'fetches/makeGetSourceGroups';

interface Props {
  sourceId: string;
  onSelect: (suggestions: any) => void;
}

const AutoPopper = withPopper(Autosuggest);

function GroupsAutosuggest({ sourceId, onSelect }: Props) {
  const classes = useStyles();
  const [input, setInput] = useState('');
  const dispatch = useDispatch();
  const getSourceGroups = makeGetSourceGroups(sourceId);
  const groupsData = useData(getSourceGroups);

  const renderSuggestion = (suggestion: any, { query, isHighlighted }: any) => {
    return DefaultSuggestion(suggestion.displayName, { query, isHighlighted });
  };

  const recalculateSuggestions = ({ value }: any) => {
    dispatch(getSourceGroups(value));
  };

  const onSuggestionSelected = (_: any, { suggestion }: any) => {
    onSelect(suggestion);

    setInput('');
  };

  const handleInputChange = (e: any) => {
    setInput(e.target.value);
  };

  return (
    <AutoPopper
      // @ts-ignore
      className={classes.root}
      inputProps={{
        value: input,
        onChange: handleInputChange,
        placeholder: 'Select Groups',
        name: 'groupAutosuggest',
        id: 'groupAutosuggest',
      }}
      renderSuggestion={renderSuggestion}
      suggestions={_get(groupsData, 'results', [])}
      onSuggestionSelected={onSuggestionSelected}
      onSuggestionsFetchRequested={recalculateSuggestions}
    />
  );
}

const useStyles = makeStyles((theme: any) => {
  return {
    root: {
      minWidth: 300,
      '& div': {
        minWidth: 300,
      },
    },
  };
});

export default GroupsAutosuggest;
